module.exports = "/images/Animal  Adventure.svg?3680f37e84f961fd0694ebebf10512ac";